/**
 * `[[apex:capture ...]]` markers are appended to assistant messages by the Nova AI
 * browser extension (apex-browser-extension `src/panel/capture-marker.ts`) to trigger
 * its scan-capture flow. The marker is part of the stored message, so conversations
 * rendered here (chat page, assistant panel, admin/shared viewer) would otherwise show
 * it raw. This mirrors the extension's strip semantics: `mode`/`keywords` attributes in
 * any order or repetition, case-insensitive, all occurrences removed, and an
 * *unterminated* marker at the end of the content dropped so a streaming bubble never
 * shows a half-arrived "[[apex:cap".
 *
 * The SPA only strips. Acting on the marker (permission gesture, tab capture) is
 * extension-only and deliberately has no counterpart here.
 */
const MARKER_SOURCE =
  '\\[\\[\\s*apex:capture((?:\\s+(?:mode|keywords)="[^"\\]]*")*)\\s*\\]\\]';

export function stripCaptureMarker(content: string): string {
  return content
    .replace(new RegExp(MARKER_SOURCE, 'gi'), '')
    .replace(/\[\[\s*apex:capture[^\]]*$/i, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}
